import { atom } from 'jotai';
import { PrizeType } from '@/components/features/casino/rush/types';

export const showCelebrationAtom = atom(false);

export enum CelebrationType {
  Crash,
  Rush,
}

export interface CelebrationInfo {
  type?: CelebrationType;
  profit?: string;
  rewardValue?: string;
  multiplier?: number;
  coinCount?: number;
  winner?: string;
}

export const CelebrationInfoAtom = atom<CelebrationInfo>({
  type: CelebrationType.Crash,
  profit: '0',
  multiplier: 0,
  winner: 'YOU',
});
